// export const API_HOST = "http://localhost:3001/api/v1/";

// export const API_HOST = "https://tint.toothlens.com/api/v1/";

// export const API_HOST = "https://tint.toothlens.com/api/v1/";

// export const API_HOST = "https://sim.toothlens.com/api/v1/";

export const API_HOST = "https://pepsodent-tint.toothlens.com/api/v1/";
